import { Link } from 'react-router-dom';
import { categories, popularCategories } from '@/mocks/categories';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/d8ukbt1l2p03kijan3u0';

export default function FooterSection() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      const statusEl = document.getElementById('newsletter-status');
      if (statusEl) {
        statusEl.textContent = 'Thanks for subscribing!';
        statusEl.className = 'text-sm text-accent-600 mt-3';
      }
      form.reset();
      return;
    }

    formData.delete('website_alt');

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value.toString());
    });

    fetch(SUBMIT_ADDR, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then(() => {
        const statusEl = document.getElementById('newsletter-status');
        if (statusEl) {
          statusEl.textContent = 'Thanks for subscribing! Check your inbox soon.';
          statusEl.className = 'text-sm text-accent-600 mt-3';
        }
        form.reset();
      })
      .catch(() => {
        const statusEl = document.getElementById('newsletter-status');
        if (statusEl) {
          statusEl.textContent = 'Something went wrong. Please try again.';
          statusEl.className = 'text-sm text-red-500 mt-3';
        }
      });
  };

  return (
    <footer className="relative bg-foreground-950 text-background-50">
      <div className="px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-14 gap-8">
            <div className="lg:max-w-xs">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold tracking-tight">
                  AllChinaBuy<span className="text-primary-500">.works</span>
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                The ultimate China sourcing spreadsheet hub. Helping ecommerce sellers discover
                winning products through structured, verified supplier data updated weekly.
              </p>
            </div>

            <div className="hidden md:grid grid-cols-3 gap-10">
              <div>
                <p className="font-heading text-sm font-bold text-background-50/80 mb-4">Categories</p>
                <ul className="space-y-2.5">
                  {popularCategories.map((cat) => {
                    const category = categories.find((c) => c.name === cat);
                    return (
                      <li key={cat}>
                        <a
                          href={category?.url || '#'}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                        >
                          {cat}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div>
                <p className="font-heading text-sm font-bold text-background-50/80 mb-4">Quick Links</p>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                    >
                      AllChinaBuy Sheet
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                    >
                      Buy It Now
                    </a>
                  </li>
                  <li>
                    <Link
                      to="/article/allchinabuyspreadsheet-complete-guide-2026"
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                    >
                      Complete Guide
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <p className="font-heading text-sm font-bold text-background-50/80 mb-4">More Categories</p>
                <ul className="space-y-2.5">
                  {categories.slice(6, 10).map((cat) => (
                    <li key={cat.slug}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                      >
                        {cat.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 items-start border-t border-background-50/10 pt-12">
            <div className="lg:w-1/3">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20product%20display%20with%20folded%20textiles%20and%20small%20decorative%20objects%20on%20a%20wooden%20shelf%20in%20a%20bright%20airy%20room%2C%20soft%20natural%20daylight%2C%20minimalist%20interior%20photography%2C%20no%20logos%2C%20no%20text%2C%20commercial%20photography%20in%20neutral%20warm%20tones&width=600&height=400&seq=footer-img-v2&orientation=landscape"
                alt="AllChinaBuySpreadsheet Products"
                className="w-full rounded-xl object-cover h-40"
                loading="lazy"
              />
            </div>

            <div className="lg:w-1/3 flex flex-col justify-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-background-50/80 leading-tight mb-3">
                The Smart
                <br />
                Way to Source
                <br />
                From China
              </p>
            </div>

            <div className="lg:w-1/3">
              <p className="text-sm text-background-50/60 leading-relaxed mb-4">
                Get weekly product updates, trending picks, and sourcing tips delivered straight to your inbox.
              </p>
              <form
                onSubmit={handleSubmit}
                data-readdy-form=""
                className="flex flex-col sm:flex-row gap-3"
              >
                <div className="form-hp-wrapper">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="flex-1 px-4 py-3 bg-background-50/10 border border-background-50/20 rounded-lg text-sm text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-accent-400 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-accent-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                  <i className="ri-arrow-right-line ml-1.5"></i>
                </button>
              </form>
              <p id="newsletter-status" className="text-sm text-accent-600 mt-3"></p>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} AllChinaBuy.works. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">Privacy Policy</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">Terms of Service</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}